$(function(){
    $('.banner_workshop').on('click',function(){
        $("html,body").animate({scrollTop:$('#dev_workshop').offset().top});
    });
});

$(function(){
    /* スライダー */
    $('.mv-slider .js_slider').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        arrows:false,
        centerMode: true,
        variableWidth: true,
        slideToShow: 1,
        dots: true,
        adaptiveHeight: true,
        respoinsive: [
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slideToShow: 1
                }
            }
        ]
    });
});